import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const SpellCheckIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SpellCheck",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M3.55 16.03c.86 0 1.55-.7 1.55-1.55v-2.6h2.08v2.6c0 .86.7 1.56 1.56 1.56s1.56-.7 1.56-1.56V4.11c0-.87-.7-1.56-1.55-1.56h-5.2C2.69 2.55 2 3.25 2 4.1v10.37c0 .86.7 1.55 1.55 1.55ZM5.11 5.66h2.07v3.11H5.11zm8.81-3.11h-.02c-.86 0-1.55.7-1.55 1.55v10.37c0 .86.7 1.55 1.55 1.55h5.18c.86 0 1.55-.7 1.55-1.55V4.11c0-.86-.68-1.55-1.53-1.56h-5.19Zm1.55 3.11h2.07v2.07h-2.07zm2.07 7.29h-2.07v-2.11h2.07zm6.74-10.4c-.86 0-1.55.7-1.55 1.55v10.37c0 .86.7 1.55 1.55 1.55h4.15c.86 0 1.56-.7 1.56-1.56s-.7-1.56-1.56-1.56h-2.59V5.61h2.6c.86 0 1.56-.7 1.56-1.56s-.7-1.56-1.56-1.56l-4.15.04ZM8.69 22.71a1.543 1.543 0 0 0 0 2.18l4.15 4.15a1.543 1.543 0 0 0 2.18 0l8.25-8.28c.34-.29.56-.71.56-1.19 0-.86-.7-1.55-1.55-1.55-.48 0-.91.22-1.19.56s-7.2 7.2-7.2 7.2l-3.01-3.06a1.543 1.543 0 0 0-2.18 0Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M7.96 3h2.89l6.82 17.94h-2.54l-1.55-4.18H5.22l-1.55 4.18H1.14zm4.76 11.51L9.4 5.56l-3.32 8.95zM18.33 17.02c0-2.28 1.62-4.13 4.59-4.13h4.13v-.74c0-2.13-1.62-3.03-3.5-3.03-1.27 0-2.69.51-4.06 1.49V8.28A8.67 8.67 0 0 1 24.06 7c2.79 0 5.25 1.77 5.25 5.2v5.97c0 .92.51 1.13 1.27.82v1.87c-.38.2-.91.33-1.42.33-1.09 0-1.93-.64-2.05-2.2-.99 1.38-2.56 2.2-4.44 2.2-2.33 0-4.33-1.62-4.33-4.18Zm8.72-1.77v-.49H23.3c-1.67 0-2.64.92-2.64 2.26s1.01 2.1 2.43 2.1c1.88 0 3.96-1.44 3.96-3.87M27.41 29.29c-.29 0-.58-.11-.81-.33l-2.49-2.49-2.5 2.49c-.45.45-1.17.44-1.62 0l-2.49-2.49-2.49 2.49c-.45.45-1.17.44-1.62 0l-2.49-2.49-2.5 2.49c-.45.45-1.17.45-1.62 0l-2.49-2.49-2.49 2.49c-.45.45-1.17.45-1.62 0a1.14 1.14 0 0 1 0-1.62l3.3-3.3a1.14 1.14 0 0 1 1.62 0l2.49 2.49 2.5-2.49a1.15 1.15 0 0 1 1.62 0l2.49 2.49 2.49-2.49a1.15 1.15 0 0 1 1.62 0l2.49 2.49 2.5-2.49a1.14 1.14 0 0 1 1.62 0l2.49 2.49 2.49-2.49a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62l-3.3 3.3c-.22.22-.52.33-.81.33"
      })
    })
  }));
};
SpellCheckIcon.displayName = 'SpellCheckIcon';